// components/ProspectionTabs.jsx
import React from "react";
import { PROSPECTION_TABS } from "../constants";

export default function ProspectionTabs({ activeTab, setActiveTab }) {
  return (
    <div className="flex flex-wrap gap-2">
      {PROSPECTION_TABS.map((tab) => {
        const active = activeTab === tab.key;

        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={[
              "group rounded-2xl border px-4 py-3 text-left transition min-w-[170px]",
              active
                ? "bg-white text-slate-950 border-white shadow-lg"
                : "bg-white/10 text-white border-white/15 hover:bg-white/20",
            ].join(" ")}
          >
            <div className="text-sm font-semibold">{tab.label}</div>
            <div
              className={[
                "mt-0.5 text-[11px] leading-snug",
                active ? "text-slate-500" : "text-white/70",
              ].join(" ")}
            >
              {tab.description}
            </div>
          </button>
        );
      })}
    </div>
  );
}